import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { KreditorService } from '../kreditor.service';

export class ApiTranslateLoader implements TranslateLoader {

  constructor(private readonly kreditorService: KreditorService) { }

  getTranslation(lang: string): Observable<any> {
    return new Observable((observer) => {
      this.kreditorService.getAnonymousServiceResult<JSON>(`localization/${lang}`).subscribe(
        data => {
          observer.next(data.result);
          observer.complete();
        },
        error => {
          console.log(error);
        }
      );
    });
  }
}